import { render, staticRenderFns } from "./card-hc-test.vue?vue&type=template&id=117f7df6&scoped=true"
import script from "./card-hc-test.vue?vue&type=script&lang=js"
export * from "./card-hc-test.vue?vue&type=script&lang=js"
import style0 from "./card-hc-test.vue?vue&type=style&index=0&id=117f7df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f7df6",
  null
  
)

export default component.exports